import styled from 'styled-components';
import { Alert } from '@mui/material';

import colors from '../../../../../../styles/colors';
import InputLabel from '../../../../../../components/v2/InputLabel';
import { ReactComponent as SaveIcon } from '../../../../../../assets/icons/v2/save.svg';

const Container = styled.div`
  width: 100%;
  padding: 0px 20px 20px 20px;
`;

const FormSection = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: 20px;
  width: 80%;
  min-width: 450px;
`;

const WorkoutDaysSection = styled(FormSection)`
  width: 100%;
`;

const Label = styled(InputLabel)`
  font-size: 12px;
  font-weight: 700;
  margin-left: 10px;
`;

const StyledFormRowScale = styled.div`
  padding-left: 10px;
  background-color: ${colors.shades.secondary10};
  border-radius: 5px;
  border: 1px solid ${colors.shades.secondary7};
`;

const EquipmentContainer = styled.div`
  display: flex;
  flex-direction: row;
  gap: 10px;
`;

const FieldContent = styled.div`
  margin: 10px;
`;

const StyledSaveIcon = styled(SaveIcon)`
  width: 15px;
  height: 15px;
  > path {
    stroke: ${colors.base.primary};
    fill: ${colors.base.secondary2};
  }
`;

const ContainerContent = styled.div`
  display: grid;
  grid-template-columns: 5fr 3fr;
`;

const UserListContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin-top: 30px;
  height: 292px;
`;

const UnaffectedClientListButtonWrapper = styled.div`
  margin-top: 30px;
  display: flex;
  flex-direction: column;
  gap: 10px;
  align-items: flex-start;
`;

const StyledAlert = styled(Alert)`
  max-width: 700px;
`;

const ProgramIdSection = styled.div`
  display: flex;
  flex-direction: column;
  margin: 0 10px;
`;

const ProgramIdValue = styled.div`
  padding: 5px 0;
  font-size: 16px;
  color: ${colors.base.secondary2};
  line-height: 148%;
`;

export {
  FormSection,
  Container,
  Label,
  StyledFormRowScale,
  EquipmentContainer,
  FieldContent,
  StyledSaveIcon,
  WorkoutDaysSection,
  ContainerContent,
  UserListContainer,
  UnaffectedClientListButtonWrapper,
  StyledAlert,
  ProgramIdSection,
  ProgramIdValue,
};
